// 搜索状态管理
export const useSearch = () => {
    // 使用 useState 确保状态在服务端/客户端/组件间共享一致
    const isSearchOpen = useState<boolean>('search-open', () => false)
  
    const openSearch = () => {
      isSearchOpen.value = true
    }
  
    const closeSearch = () => {
      isSearchOpen.value = false
    }
  
    const toggleSearch = () => {
      isSearchOpen.value = !isSearchOpen.value
    }
  
    return {
      isSearchOpen,
      openSearch,
      closeSearch,
      toggleSearch
    }
  }
  